import { Injectable, OnDestroy, signal } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class NetworkStatusService implements OnDestroy {
	public readonly isOnline = signal(navigator.onLine);

	constructor() {
		window.addEventListener('online', this.onOnline);
		window.addEventListener('offline', this.onOffline);
	}

	public ngOnDestroy(): void {
		window.removeEventListener('online', this.onOnline);
		window.removeEventListener('offline', this.onOffline);
	}

	private readonly onOnline = (): void => this.isOnline.set(true);
	private readonly onOffline = (): void => this.isOnline.set(false);
}
